import { render, staticRenderFns } from "./MainAccounts.vue?vue&type=template&id=c211aa7a&scoped=true"
import script from "./MainAccounts.vue?vue&type=script&lang=js"
export * from "./MainAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c211aa7a",
  null
  
)

export default component.exports